
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexmYaJdMUb4M2Epx9NrVRAzlyevYj55ySc3LdkvtwCV4EMeta } from "/opt/baserow/web-frontend/modules/core/pages/index.vue?macro=true";
import { default as debugy5iKB1PuPNA3Od__ldCuUYDdPbAq1eWlQrU8UtVr0GQMeta } from "/opt/baserow/web-frontend/modules/core/pages/debug.vue?macro=true";
import { default as loginpoXq_VsVfRifz_45YwpLYRY1aotLT5NYBvP0FiriW48X8Meta } from "/opt/baserow/web-frontend/modules/core/pages/login.vue?macro=true";
import { default as signuphrRd6QJt1a8QfjRH0iPQOlBwfkjH8rZ8d6hjOs_jcq0Meta } from "/opt/baserow/web-frontend/modules/core/pages/signup.vue?macro=true";
import { default as forgotPasswordjneXBYdSDjBlWWG_wSarAnJJ7U8jsVoZk8aE_CqqflUMeta } from "/opt/baserow/web-frontend/modules/core/pages/forgotPassword.vue?macro=true";
import { default as resetPasswordL_45pJCadBs5jSUX4kU5Yxhiv5OqVV8ZTTfvOkzgcZiZsMeta } from "/opt/baserow/web-frontend/modules/core/pages/resetPassword.vue?macro=true";
import { default as changeEmailwT_45DYo7M0v9FYuDIo_45VO3MNH5PyWSR5RWzLQzjFZ8_45oMeta } from "/opt/baserow/web-frontend/modules/core/pages/changeEmail.vue?macro=true";
import { default as verifyEmailAddress5Tkoo8WqaCqSMslRLjVj1Czf23KJg_45M6FGCXwm4xmLEMeta } from "/opt/baserow/web-frontend/modules/core/pages/verifyEmailAddress.vue?macro=true";
import { default as styleGuideI0QHpuBaalsjMKt57ihwNU7QnL160a3b1qfZn9UEy4oMeta } from "/opt/baserow/web-frontend/modules/core/pages/styleGuide.vue?macro=true";
import { default as loginWithSAMLKB5F_47hCSAnV_45MFfDTHYfgMxSY7XZyvZUNZJ19tq3MMeta } from "/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue?macro=true";
import { default as loginErrorbaw45fHKAt8rOGPj7v8Jzmpd9xpTwMV3LIHGAhvDH7cMeta } from "/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue?macro=true";
import { default as loginPageshhDcpikn0Z_E4HJtbuIwueJo26B_80PFZDAJa5mm9HwMeta } from "/opt/baserow/web-frontend/modules/core/pages/loginPages.vue?macro=true";
import { default as dashboardK5bPa6tTVvV_iVBJrcqPK7LlBlhY_T3zBsf1AHnkX7QMeta } from "/opt/baserow/web-frontend/modules/core/pages/dashboard.vue?macro=true";
import { default as workspacehaJnauBCetm07wrEFS0z5FX00Yo1BH3bQJXCxLG_FokMeta } from "/opt/baserow/web-frontend/modules/core/pages/workspace.vue?macro=true";
import { default as settingsFB9TsG_45iXs_45ZunZqGHqid_45skQSBuhNeRDuVWpPJSyRAMeta } from "/opt/baserow/web-frontend/modules/core/pages/admin/settings.vue?macro=true";
import { default as healthyw0yckiU_m_45GJb3fLIhrqKtX9KB08lzv_0ODDITuXdYMeta } from "/opt/baserow/web-frontend/modules/core/pages/admin/health.vue?macro=true";
import { default as dashboardAXz96qxvRO5OLzIkA4TqWUGC7DsBGHqnYrXj3DVmU6QMeta } from "/opt/baserow/web-frontend/modules/core/pages/admin/dashboard.vue?macro=true";
import { default as usersQJlOVAV_kkIFSljEjd1b6_45cc_fCmEkPrzjOnOV9aPwQMeta } from "/opt/baserow/web-frontend/modules/core/pages/admin/users.vue?macro=true";
import { default as workspacesBaABrokkU111mL9H3_l1wLoksc_45B8sKxgb0eYW2An60Meta } from "/opt/baserow/web-frontend/modules/core/pages/admin/workspaces.vue?macro=true";
import { default as membersjDOkEONut4NSlp69ibBHwzFXjE6AMGb1nZCpwKHMP4cMeta } from "/opt/baserow/web-frontend/modules/core/pages/settings/members.vue?macro=true";
import { default as invitesDr6api7aaS3qA_hSZc1T8SPtvYUXFmP2rVLGZ9FsFBsMeta } from "/opt/baserow/web-frontend/modules/core/pages/settings/invites.vue?macro=true";
import { default as teamsn6ftPF5z2o_45oTlpeVh3hD04NHo58xd_G5J6JI1mklugMeta } from "/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue?macro=true";
import { default as settingscZDXEv1M22UPtJvZ_45wqm5TR6QkQsKSBYCnE05hzHFdcMeta } from "/opt/baserow/web-frontend/modules/core/pages/settings.vue?macro=true";
import { default as authProvidersG7EBpxOjoDKo7xe923v_45sSJwk_45WZbQRUhJ9avyXD3NsMeta } from "/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue?macro=true";
import { default as auditLogTxcgiQpnHIYiLn8mDR1lqsqpbvsNLdSrEwbSjCHpt2oMeta } from "/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue?macro=true";
import { default as rootAc4zxaeHXysVofmhrwkcYWe8xbmH_0CIvIpIUi_eqt4Meta } from "/opt/baserow/web-frontend/modules/core/pages/root.vue?macro=true";
import { default as workspaceInvitation7UPAcJSi6EoUcDkZfXlvaiBw9Lu3OxiKlKHt8E0C_7cMeta } from "/opt/baserow/web-frontend/modules/core/pages/workspaceInvitation.vue?macro=true";
import { default as templatec0vg_rl3frNJ40NU_454bOFxeV4EXhlGRUl1kX9N6SBjsMeta } from "/opt/baserow/web-frontend/modules/core/pages/template.vue?macro=true";
import { default as _healthLWQ03MrWnn2z6jNc_457xvHWn3xFhPzDuH_45s0_45UK4HEvMMeta } from "/opt/baserow/web-frontend/modules/core/pages/_health.vue?macro=true";
import { default as notificationRedirectEWNTFy06wjN3VSxYDMWdoM3pSkDZ3LTyBI4zmUjvw9gMeta } from "/opt/baserow/web-frontend/modules/core/pages/notificationRedirect.vue?macro=true";
import { default as onboardingn6oEf_xxWNixOCZXGXJYc5behp4EkuzvKsk7otoGLq0Meta } from "/opt/baserow/web-frontend/modules/core/pages/onboarding.vue?macro=true";
import { default as RouterViewPlaceholderjjEM848l2I6XeJjmFSebRnw_3Qcfh_l2GDspJDPnyuEMeta } from "/opt/baserow/web-frontend/modules/core/components/RouterViewPlaceholder.vue?macro=true";
import { default as webhooksuYRlDrVKJls4dij6rcKPYgWQ7IpnwFDRn8HHh2CV4ekMeta } from "/opt/baserow/web-frontend/modules/database/pages/table/webhooks.vue?macro=true";
import { default as configureDataSyncylsRusI_H1VzoFBujyNlcDIRsxaqq_IYfMU7jedZIMIMeta } from "/opt/baserow/web-frontend/modules/database/pages/table/configureDataSync.vue?macro=true";
import { default as tablefe1q9zU_45sDIMe47GyhwPaWjWEpea1VBB8RU5SphayxcMeta } from "/opt/baserow/web-frontend/modules/database/pages/table.vue?macro=true";
import { default as rootGe93ESyPn6rzrlPNxfUr94qn6r5HVDFgfGiveru_45FXEMeta } from "/opt/baserow/web-frontend/modules/database/pages/root.vue?macro=true";
import { default as APIDocszKRmprU1TP_45oLzK_0w7yQz7wDYAOFuaTCrYULfLyXKwMeta } from "/opt/baserow/web-frontend/modules/database/pages/APIDocs.vue?macro=true";
import { default as APIDocsDatabasevaluFwloaeF6ofCgqDCD3ztIa2wy_QTEmM3uKLwmTS8Meta } from "/opt/baserow/web-frontend/modules/database/pages/APIDocsDatabase.vue?macro=true";
import { default as formOpbnVQpGp9swksh46U0jBSJw5tZj5jbsL89SP_cM3boMeta } from "/opt/baserow/web-frontend/modules/database/pages/form.vue?macro=true";
import { default as publicViewadiKNTNH_l7ZGeebTR3qQkg9cOOC8S67ZzJYR6F4oQUMeta } from "/opt/baserow/web-frontend/modules/database/pages/publicView.vue?macro=true";
import { default as publicViewLoginR_45Ua0ZhJJYyYBwlpuNAQyULKITuGDT5_45GOJVRixCnlMMeta } from "/opt/baserow/web-frontend/modules/database/pages/publicViewLogin.vue?macro=true";
import { default as dashboardwhyQtl4EYekkYOqd55W5bnu45jGA9PpsdBOtyVQ45TMMeta } from "/opt/baserow/web-frontend/modules/dashboard/pages/dashboard.vue?macro=true";
import { default as pageEditor_98ufSt7V5K1U8HHIeFtNYVzDsXlehSPJJ_45YxvaptBsMeta } from "/opt/baserow/web-frontend/modules/builder/pages/pageEditor.vue?macro=true";
import { default as publicPage5H9bzL_rWfB3PgEXuzkW61JOGXBrAiYMP9mogzt9lDoMeta } from "/opt/baserow/web-frontend/modules/builder/pages/publicPage.vue?macro=true";
import { default as automationWorkflowx50UoSSJ9OnS1opN6mzqw03hVYIgqJA0BtZlFB3ODCwMeta } from "/opt/baserow/web-frontend/modules/automation/pages/automationWorkflow.vue?macro=true";
import { default as licensesabEsvo5z2q7yEzq8DUN8sXWL3G3NNVIksnqXONW82gMMeta } from "/opt/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue?macro=true";
import { default as licenseWKOak0gcZSwh3YbZ8C3ZBu1El9NrGWp99mfQUQHAPcMMeta } from "/opt/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue?macro=true";
import { default as rootQRdUzxfu4WDk6irSJphc6ME0Py7uiNvzoh_455qrSz2roMeta } from "/opt/baserow/premium/web-frontend/modules/baserow_premium/pages/root.vue?macro=true";
import { default as publicViewic0BLFnKa9D79LeCccGHGRa0RQ5dtQAxboPDW3rHy9wMeta } from "@baserow/modules/database/pages/publicView.vue?macro=true";
export default [
  {
    name: "index",
    path: "",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/index.vue")
  },
  {
    name: "debug",
    path: "/debug",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/debug.vue")
  },
  {
    name: "login-pages",
    path: "",
    meta: { ...(loginPageshhDcpikn0Z_E4HJtbuIwueJo26B_80PFZDAJa5mm9HwMeta || {}), ...{"middleware":["settings","urlCheck","settings","urlCheck"]} },
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/loginPages.vue"),
    children: [
  {
    name: "login",
    path: "/login",
    meta: { ...(loginpoXq_VsVfRifz_45YwpLYRY1aotLT5NYBvP0FiriW48X8Meta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(signuphrRd6QJt1a8QfjRH0iPQOlBwfkjH8rZ8d6hjOs_jcq0Meta || {}), ...{"middleware":["settings","settings"]} },
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/signup.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgotPasswordjneXBYdSDjBlWWG_wSarAnJJ7U8jsVoZk8aE_CqqflUMeta || {},
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/forgotPassword.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/resetPassword.vue")
  },
  {
    name: "change-email",
    path: "/change-email/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/changeEmail.vue")
  },
  {
    name: "verify-email-address",
    path: "/verify-email-address/:token",
    meta: verifyEmailAddress5Tkoo8WqaCqSMslRLjVj1Czf23KJg_45M6FGCXwm4xmLEMeta || {},
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/verifyEmailAddress.vue")
  },
  {
    name: "style-guide",
    path: "/style-guide",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/styleGuide.vue")
  },
  {
    name: "login-saml",
    path: "/login/saml",
    meta: loginWithSAMLKB5F_47hCSAnV_45MFfDTHYfgMxSY7XZyvZUNZJ19tq3MMeta || {},
    component: () => import("/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginWithSAML.vue")
  },
  {
    name: "login-error",
    path: "/login/error",
    meta: loginErrorbaw45fHKAt8rOGPj7v8Jzmpd9xpTwMV3LIHGAhvDH7cMeta || {},
    component: () => import("/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/login/loginError.vue")
  }
]
  },
  {
    name: "root",
    path: "",
    meta: { ...(rootAc4zxaeHXysVofmhrwkcYWe8xbmH_0CIvIpIUi_eqt4Meta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/root.vue"),
    children: [
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardK5bPa6tTVvV_iVBJrcqPK7LlBlhY_T3zBsf1AHnkX7QMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","pendingJobs","settings","authenticated","impersonate","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/dashboard.vue")
  },
  {
    name: "workspace",
    path: "/workspace/:workspaceId",
    meta: { ...(workspacehaJnauBCetm07wrEFS0z5FX00Yo1BH3bQJXCxLG_FokMeta || {}), ...{"middleware":["settings","authenticated","impersonate","workspacesAndApplications","settings","authenticated","impersonate","workspacesAndApplications"]} },
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/workspace.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/admin/settings.vue")
  },
  {
    name: "admin-health",
    path: "/admin/health",
    meta: { ...(healthyw0yckiU_m_45GJb3fLIhrqKtX9KB08lzv_0ODDITuXdYMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/admin/health.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/admin/dashboard.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/admin/users.vue")
  },
  {
    name: "admin-workspaces",
    path: "/admin/workspaces",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/admin/workspaces.vue")
  },
  {
    name: "settings",
    path: "/workspace/:workspaceId/settings",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/settings.vue"),
    children: [
  {
    name: "settings-members",
    path: "members",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/settings/members.vue")
  },
  {
    name: "settings-invites",
    path: "invites",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/settings/invites.vue")
  },
  {
    name: "settings-teams",
    path: "teams",
    component: () => import("/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/settings/teams.vue")
  }
]
  },
  {
    name: "admin-auth-providers",
    path: "/admin/auth-providers",
    meta: { ...(authProvidersG7EBpxOjoDKo7xe923v_45sSJwk_45WZbQRUhJ9avyXD3NsMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/admin/authProviders.vue")
  },
  {
    name: "admin-audit-log",
    path: "/admin/audit-log",
    meta: { ...(auditLogTxcgiQpnHIYiLn8mDR1lqsqpbvsNLdSrEwbSjCHpt2oMeta || {}), ...{"middleware":"authenticated"} },
    component: () => import("/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  },
  {
    name: "workspace-audit-log",
    path: "/workspace/:workspaceId/audit-log",
    component: () => import("/opt/baserow/enterprise/web-frontend/modules/baserow_enterprise/pages/auditLog.vue")
  }
]
  },
  {
    name: "workspace-invitation",
    path: "/workspace-invitation/:token",
    meta: {"preventPageViewTracking":true},
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/workspaceInvitation.vue")
  },
  {
    name: "template",
    path: "/template/:slug",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/template.vue")
  },
  {
    name: "health-check",
    path: "/_health/:trailing()?",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "notification-redirect",
    path: "/notification/:workspaceId/:notificationId",
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/notificationRedirect.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingn6oEf_xxWNixOCZXGXJYc5behp4EkuzvKsk7otoGLq0Meta || {},
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/onboarding.vue")
  },
  {
    name: "database-table",
    path: "/database/:databaseId/table/:tableId/:viewId?",
    meta: { ...(tablefe1q9zU_45sDIMe47GyhwPaWjWEpea1VBB8RU5SphayxcMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs","settings","authenticated","workspacesAndApplications","tableLoading","selectWorkspaceDatabaseTable","pendingJobs"]} },
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/table.vue"),
    children: [
  {
    name: "database-table-row",
    path: "row/:rowId",
    component: () => import("/opt/baserow/web-frontend/modules/core/components/RouterViewPlaceholder.vue")
  },
  {
    name: "database-table-open-webhooks",
    path: "webhooks",
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/table/webhooks.vue")
  },
  {
    name: "database-table-open-configure-data-sync",
    path: "configure-data-sync/:selectedPage?",
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/table/configureDataSync.vue")
  }
]
  },
  {
    name: "database-root",
    path: "",
    meta: { ...(rootGe93ESyPn6rzrlPNxfUr94qn6r5HVDFgfGiveru_45FXEMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/root.vue")
  },
  {
    path: "/api/docs",
    name: "database-api-docs-redirect",
    redirect: "/api-docs"
  },
  {
    path: "/api/docs/database/:databaseId",
    name: "database-api-docs-details-redirect",
    redirect: "/api-docs/database/:databaseId"
  },
  {
    name: "database-api-docs",
    path: "/api-docs",
    meta: { ...(APIDocszKRmprU1TP_45oLzK_0w7yQz7wDYAOFuaTCrYULfLyXKwMeta || {}), ...{"middleware":["workspacesAndApplications","workspacesAndApplications"]} },
    alias: ["/api/docs"],
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/APIDocs.vue")
  },
  {
    name: "database-api-docs-detail",
    path: "/api-docs/database/:databaseId",
    meta: {"middleware":["workspacesAndApplications","workspacesAndApplications"]},
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/APIDocsDatabase.vue")
  },
  {
    name: "database-table-form",
    path: "/form/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/form.vue")
  },
  {
    name: "database-public-grid-view",
    path: "/public/grid/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-gallery-view",
    path: "/public/gallery/:slug",
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-view-auth",
    path: "/public/auth/:slug",
    meta: { ...(publicViewLoginR_45Ua0ZhJJYyYBwlpuNAQyULKITuGDT5_45GOJVRixCnlMMeta || {}), ...{"layout":"login"} },
    component: () => import("/opt/baserow/web-frontend/modules/database/pages/publicViewLogin.vue")
  },
  {
    name: "dashboard-application",
    path: "/dashboard/:dashboardId",
    meta: { ...(dashboardwhyQtl4EYekkYOqd55W5bnu45jGA9PpsdBOtyVQ45TMMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","dashboardLoading","settings","authenticated","workspacesAndApplications","dashboardLoading"]} },
    component: () => import("/opt/baserow/web-frontend/modules/dashboard/pages/dashboard.vue")
  },
  {
    name: "builder-page",
    path: "/builder/:builderId/page/:pageId",
    meta: { ...(pageEditor_98ufSt7V5K1U8HHIeFtNYVzDsXlehSPJJ_45YxvaptBsMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs","settings","authenticated","workspacesAndApplications","selectWorkspaceBuilderPage","pendingJobs"]} },
    component: () => import("/opt/baserow/web-frontend/modules/builder/pages/pageEditor.vue")
  },
  {
    name: "application-builder-page",
    path: "/:pathMatch(.*)*",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/opt/baserow/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "builder-health-check",
    path: "/_health",
    meta: {"publishedBuilderRoute":true},
    component: () => import("/opt/baserow/web-frontend/modules/core/pages/_health.vue")
  },
  {
    name: "application-builder-preview",
    path: "/builder/:builderId/preview/:pathMatch(.*)*",
    component: () => import("/opt/baserow/web-frontend/modules/builder/pages/publicPage.vue")
  },
  {
    name: "automation-workflow",
    path: "/automation/:automationId/workflow/:workflowId",
    meta: { ...(automationWorkflowx50UoSSJ9OnS1opN6mzqw03hVYIgqJA0BtZlFB3ODCwMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/opt/baserow/web-frontend/modules/automation/pages/automationWorkflow.vue")
  },
  {
    name: "premium-root",
    path: "",
    meta: { ...(rootQRdUzxfu4WDk6irSJphc6ME0Py7uiNvzoh_455qrSz2roMeta || {}), ...{"middleware":["settings","authenticated","workspacesAndApplications","pendingJobs","settings","authenticated","workspacesAndApplications","pendingJobs"]} },
    component: () => import("/opt/baserow/premium/web-frontend/modules/baserow_premium/pages/root.vue"),
    children: [
  {
    name: "admin-licenses",
    path: "/admin/licenses",
    meta: { ...(licensesabEsvo5z2q7yEzq8DUN8sXWL3G3NNVIksnqXONW82gMMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/licenses.vue")
  },
  {
    name: "admin-license",
    path: "/admin/license/:id",
    meta: { ...(licenseWKOak0gcZSwh3YbZ8C3ZBu1El9NrGWp99mfQUQHAPcMMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/baserow/premium/web-frontend/modules/baserow_premium/pages/admin/license.vue")
  }
]
  },
  {
    name: "database-public-kanban-view",
    path: "/public/kanban/:slug",
    meta: {"middleware":["settings","settings"]},
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-calendar-view",
    path: "/public/calendar/:slug",
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  },
  {
    name: "database-public-timeline-view",
    path: "/public/timeline/:slug",
    component: () => import("@baserow/modules/database/pages/publicView.vue")
  }
]